import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function AAPage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [sessionId, setSessionId] = useState(searchParams.get('sessionId') || searchParams.get('session_id') || '');
    const [consentHandle, setConsentHandle] = useState(searchParams.get('consentHandle') || searchParams.get('consent_handle') || '');
    const [consentId, setConsentId] = useState(searchParams.get('consentId') || searchParams.get('consent_id') || '');
    const [status, setStatus] = useState(searchParams.get('status') || 'redirected');
    const [message] = useState(searchParams.get('message') || 'Your bank consent flow has been opened successfully.');
    const API_URL = process.env.REACT_APP_API_URL || '';

    const redirectTarget = useMemo(() => '/dashboard/apply-loan', []);

    useEffect(() => {
        const qpSession = searchParams.get('sessionId') || searchParams.get('session_id') || '';
        const qpHandle = searchParams.get('consentHandle') || searchParams.get('consent_handle') || '';
        const qpConsent = searchParams.get('consentId') || searchParams.get('consent_id') || '';
        if (qpSession || qpHandle || qpConsent) {
            setSessionId(qpSession);
            setConsentHandle(qpHandle);
            setConsentId(qpConsent);
        }
    }, [searchParams]);

    useEffect(() => {
        const session = JSON.parse(localStorage.getItem('userSession') || '{}');
        if (!session?.userId) return;

        const params = new URLSearchParams();
        if (sessionId) params.set('sessionId', sessionId);
        if (consentId) params.set('consentId', consentId);
        if (consentHandle) params.set('consentHandle', consentHandle);
        if (!params.toString()) return;

        fetch(`${API_URL}/api/moneyone/session-status?${params.toString()}`, {
            headers: { 'Authorization': `Bearer ${session?.token || ''}` }
        })
            .then(res => res.json())
            .then(json => {
                if (json?.success && json.session) {
                    const sessionState = json.session;
                    if (sessionState.consent_status) setStatus(sessionState.consent_status);
                    if (sessionState.fi_data_status === 'FETCHED') {
                        setStatus('COMPLETED');
                    }
                }
            })
            .catch(() => {});
    }, [API_URL, consentHandle, consentId, sessionId]);

    return (
        <div style={{
            minHeight: '100vh',
            display: 'grid',
            placeItems: 'center',
            padding: '24px',
            background: 'linear-gradient(135deg, #fff7ed, #ffffff 55%, #ecfeff)'
        }}>
            <div style={{
                width: 'min(720px, 100%)',
                borderRadius: '28px',
                padding: '28px',
                background: 'rgba(255,255,255,0.95)',
                border: '1px solid #e2e8f0',
                boxShadow: '0 24px 60px rgba(15, 23, 42, 0.08)'
            }}>
                <div style={{ fontSize: '44px', marginBottom: '8px' }}>🏦</div>
                <div style={{
                    display: 'inline-flex',
                    padding: '6px 12px',
                    borderRadius: '999px',
                    background: '#fff7ed',
                    color: '#c2410c',
                    fontSize: '12px',
                    fontWeight: 800,
                    letterSpacing: '0.08em',
                    textTransform: 'uppercase'
                }}>
                    Account Aggregator
                </div>
                <h1 style={{ margin: '14px 0 8px', fontSize: '30px', color: '#0f172a' }}>
                    Bank link started
                </h1>
                <p style={{ margin: 0, color: '#475569', lineHeight: 1.6 }}>
                    {message}
                </p>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                    gap: '12px',
                    marginTop: '22px'
                }}>
                    <div style={{ padding: '14px', borderRadius: '16px', background: '#f8fafc', border: '1px solid #e2e8f0' }}>
                        <div style={{ fontSize: '11px', fontWeight: 800, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Session</div>
                        <div style={{ marginTop: '6px', color: '#0f172a', wordBreak: 'break-word' }}>{sessionId || 'Pending'}</div>
                    </div>
                    <div style={{ padding: '14px', borderRadius: '16px', background: '#f8fafc', border: '1px solid #e2e8f0' }}>
                        <div style={{ fontSize: '11px', fontWeight: 800, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Consent</div>
                        <div style={{ marginTop: '6px', color: '#0f172a', wordBreak: 'break-word' }}>{consentHandle || consentId || 'Pending'}</div>
                    </div>
                    <div style={{ padding: '14px', borderRadius: '16px', background: '#f8fafc', border: '1px solid #e2e8f0' }}>
                        <div style={{ fontSize: '11px', fontWeight: 800, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Status</div>
                        <div style={{ marginTop: '6px', color: '#0f172a' }}>{status}</div>
                    </div>
                </div>

                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginTop: '22px' }}>
                    <button
                        onClick={() => navigate(redirectTarget)}
                        style={{
                            border: 'none',
                            borderRadius: '12px',
                            padding: '12px 18px',
                            background: 'linear-gradient(135deg, #d97706, #2563eb)',
                            color: '#fff',
                            fontWeight: 700,
                            cursor: 'pointer'
                        }}
                    >
                        Back to AA step
                    </button>
                    <button
                        onClick={() => navigate('/dashboard')}
                        style={{
                            border: '1px solid #e2e8f0',
                            borderRadius: '12px',
                            padding: '12px 18px',
                            background: '#fff',
                            color: '#475569',
                            fontWeight: 700,
                            cursor: 'pointer'
                        }}
                    >
                        Go to dashboard
                    </button>
                </div>
            </div>
        </div>
    );
}
